import './StackTraceDisplay.css';

import { Button, Col, Container, Form, Overlay, Row, Tooltip } from 'react-bootstrap';
import React, { useEffect, useRef, useState } from 'react';

import Icon from '@amzn/meridian/icon';
import copyTokens from '@amzn/meridian-tokens/base/icon/copy';

const StackTraceDisplay = ({ text }) => {
  const [lines, setLines] = useState([]);
  const [filter, setFilter] = useState('');
  const [showCopiedTooltip, setShowCopiedTooltip] = useState(false);
  const tooltipTarget = useRef(null);

  useEffect(() => {
    const prepareText = text => {
      if (text.trim().length === 0) {
        return new Map();
      }

      const lines = text.split('\n');
      const mapOfLines = new Map();

      let i = 1;
      for (const line of lines) {
        let formattedLine = line.trim();
        if (formattedLine.startsWith('at')) {
          formattedLine = `  ${formattedLine}`;
        }

        mapOfLines.set(i, formattedLine);
        i += 1;
      }

      return mapOfLines;
    };

    const linesFromText = [...prepareText(text)];
    setLines(linesFromText);
  }, [text]);

  useEffect(() => {
    if (showCopiedTooltip === false) {
      return;
    }

    const timer = setTimeout(() => setShowCopiedTooltip(false), 3000);
    return () => clearTimeout(timer);
  }, [showCopiedTooltip]);

  const copyLinesToClipboard = () => {
    const completedText = lines
      .filter(line => filter === '' || line[1].indexOf(filter) >= 0)
      .map(line => line[1])
      .join('\n');

    navigator.clipboard
      .writeText(completedText)
      .then(() => setShowCopiedTooltip(true))
      .catch(e => console.log(e));
  };

  const filteredLines = lines.filter(line => filter === '' || line[1].indexOf(filter) >= 0);
  const lineNumbers = (
    <code>
      {filteredLines.map(line => (
        <React.Fragment key={line[0]}>
          {line[0]}
          <br />
        </React.Fragment>
      ))}
    </code>
  );
  const lineTexts = (
    <code>
      {filteredLines.map(line => (
        <React.Fragment key={line[0]}>
          {line[1]}
          <br />
        </React.Fragment>
      ))}
    </code>
  );

  return (
    <Container fluid className="mt-2 mb-2 grey-border p-2">
      <Row className="mb-2">
        <Col>
          <Form.Control
            type="text"
            placeholder="Input filter here"
            value={filter}
            onChange={e => {
              setFilter(e.target.value);
            }}
          />
        </Col>
      </Row>
      <Row className="overflow-x height-some-lines">
        <Button
          className="position-absolute left-92p on-top"
          variant="outline-secondary"
          size="sm"
          onClick={() => copyLinesToClipboard()}
          ref={tooltipTarget}
        >
          <Icon tokens={copyTokens}></Icon>
        </Button>
        <Overlay target={tooltipTarget.current} show={showCopiedTooltip} placement="left">
          {props => (
            <Tooltip id="copied-tooltip" {...props}>
              Copied!
            </Tooltip>
          )}
        </Overlay>
        <Col className="d-block small-col">{lineNumbers}</Col>
        <Col className="ml-0 col-11 d-block white-space-nowrap overflow-y">{lineTexts}</Col>
      </Row>
    </Container>
  );
};

export default StackTraceDisplay;
